/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
/* eslint-disable no-alert */

import { createApp } from 'vue';
import axios from 'axios';
import Global from 'vue@/plugin/global';
import { centrifuge } from 'vue@/centrifuge.js';
import CategorySelect from './CategorySelect.vue';


// eslint-disable-next-line no-new
createApp({
    data: () => ({
        sub: null,
        event: window.pricelist.event,
        registrations: window.pricelist.registrations,
        classes: window.pricelist.classes || [],
        selectedClass: null,
        is_admin: window.pricelist.is_admin,
        preselectClass: window.pricelist.preselect_class ?? true,
    }),

    components: {
        CategorySelect
    },

    computed: {
        filteredRegistrations() {
            if (!this.classes.length) {
                return this.registrations;
            }
            if (this.selectedClass === null) {
                return [];
            }
            return this.registrations.filter((r) => r.class_id === this.selectedClass);
        },

        isConnected() {
            return this.sub?.ready();
        },
    },

    beforeMount() {
        if (this.is_admin) {
            this.sub = centrifuge.newSubscription(`sc:event-admin-${this.event.id}`);
        } else {
            this.sub = centrifuge.newSubscription(`sc:event-${this.event.id}`);
        }

        this.sub.on('publication', (ctx) => {
            const {data} = ctx;

            if (!data || !data.freestyle) {
                return;
            }

            const { class_id: classId, registrations } = data.freestyle;

            if (!Array.isArray(registrations)) {
                return;
            }

            this.registrations = this.registrations
                .filter((r) => r.class_id !== classId)
                .concat(registrations);

            this.sortRegistrations();
        });

        this.sub.subscribe();
    },

    created() {
        if (this.preselectClass && this.classes.length) {
            this.selectedClass = this.classes[0].id;
        }
    },
    methods: {
        placementSortKey(registration) {
            if (registration.placement === -1) {
                return Number.MAX_SAFE_INTEGER;
            }
            if (registration.placement === null || registration.placement === undefined) {
                return Number.MAX_SAFE_INTEGER - 1;
            }
            return registration.placement;
        },

        sortRegistrations() {
            this.registrations.sort(
                (a, b) => this.placementSortKey(a) - this.placementSortKey(b)
            );
        },

        filterByClass(classId) {
            this.selectedClass = classId || null;
        },

        showsClass(classId) {
            if (!this.classes.length) {
                return true;
            }
            return this.selectedClass !== null && this.selectedClass === classId;
        },
        async exportCsv() {
            const url = route('events::results::exportTaxPricelist', { huntingTestEvent: this.event.id });
            try {
                await axios.post(url, {
                    registrations: this.registrations,
                });
                alert('Exporten har startats. Du kommer få ett meddelande när den är redo att hämtas.');
            } catch (error) {
                console.error(error);
                alert('Något gick fel. Försök igen senare eller kontakta supporten.');
            }
        },

        async refreshFreestyleResults() {
            const url = route('events::results::refreshFreestyleResults', { huntingTestEvent: this.event.id });
            const { data } = await axios.get(url);
            this.registrations = data.registrations;
        },

        async publishResults() {
            const url = route('events::results::publishFreestyleResults', { huntingTestEvent: this.event.id, class_id: this.selectedClass });
            try {
                await axios.post(url);
                await this.refreshFreestyleResults();
                alert('Resultatet har publicerats');
            } catch (error) {
                console.error(error);
                alert('Något gick fel. Försök igen senare eller kontakta supporten.');
            }
        },

        async exportCsvChase() {
            const url = route('events::results::exportChasePricelist', { huntingTestEvent: this.event.id });
            try {
                await axios.post(url, {
                    registrations: this.registrations,
                });

                alert('Exporten har startats. Du kommer få ett meddelande när den är redo att hämtas.');

            } catch (error) {
                console.error(error);
                alert('Något gick fel. Försök igen senare eller kontakta supporten.');
            }
        },
        async exportCsvSvk() {
            const url = route('events::results::exportSvkPricelist', { huntingTestEvent: this.event.id });
            try {
                await axios.post(url, {
                    registrations: this.registrations,
                });

                alert('Exporten har startats. Du kommer få ett meddelande när den är redo att hämtas.');
            } catch (error) {
                console.error(error);
                alert('Något gick fel. Försök igen senare eller kontakta supporten.');
            }
        },
    }
}).use(Global).mount('#pricelist');

